export default __webpack_public_path__ + "static/media/HelpChat.accbf2d2.svg";